/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Image from 'material/embeds/imageapi/imagepane/image/image_container';
import Loading from 'material/embeds/imageapi/imagepane/loading/loading';
//utils
import { unsplashCancel, defaultQuery } from 'utils/api/embed';
import { UNSPLASH } from 'state/actions/embedsState/embedManagementState/image_status';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/images/unsplash/unsplash_styles';



/* ========== ~~~~~~~~~~ UNSPLASH ~~~~~~~~~~ ========== */
class Unsplash extends Component {

	constructor(props) {
		super(props);
		this.processUnsplashSearch=this.processUnsplashSearch.bind(this);
	};
	
	componentDidMount(){
		this.processUnsplashSearch(this.props.query, this.props.page);
	}

	componentDidUpdate(prevProps){
		if (prevProps.query !== this.props.query || prevProps.page !== this.props.page){
			this.processUnsplashSearch(this.props.query, this.props.page);
		}
	}

	componentWillUnmount(){
		if (!this.props.isDataReceived){
			unsplashCancel();
		}
	}

	processUnsplashSearch(query, page){
		if (query==''){
			this.props.getUnsplash(defaultQuery, page);
		} else {
			this.props.getUnsplash(query, page);
		}
	}

	renderImages() {
			return this.props.images.data.map((image, i) => {
				let thumbnail = image.urls.thumb;
				let photographer = image.user.name;
				let linkToProfile = image.user.links.html+'?utm_source=insticator&utm_medium=referral';
				return (
					<span className={`imagecontainer`} key={i}>
						<Image key={`unsplash-image-${i}`} provider={'UNSPLASH'} id={image.id}
							previewUrl={image.urls.small} attribution={{photographer, linkToProfile}}
							url={thumbnail} height={200*(image.height/image.width)} width={200} />
					</span>
				)
			});
	};

	render() {
		return (
			<div className={`pane unsplash ${this.props.classes.unsplash}`}>
				{(this.props.provider === UNSPLASH && this.props.isDataReceived && this.props.images.length > 0 && !this.props.error) ? <div className={`innerPane`}>
					{this.renderImages()}
				</div> : <Loading error = {this.props.error} images={(this.props.isDataReceived && this.props.images.length === 0)} />}
			</div>
		)
	};
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Unsplash);
